module.exports = __webpack_public_path__ + "img/xiangjiangxu.eacd8381.png";